import dictionary from './lang/dictionary.json';

export const translate = (id: string, values?: any): string => {
    const locale: string = 'vi-VN';
    let sentence: string;

    // @ts-ignore
    if (dictionary[id] && dictionary[id][locale]) {
        // @ts-ignore
        sentence = dictionary[id][locale]
    } else {
        console.warn(`Don't have any messages match with id: "${id}"`);
        return `{${id}}`
    }

    // Match values
    if (typeof values === 'object') {
        Object.entries(values).map(item => {
            // @ts-ignore
            sentence = sentence.replace(new RegExp(`{${item[0]}}`, 'g'), item[1])
            return item
        })
    }

    return sentence
}

export const getLocaleKey = (): string => 'vi-VN'